import { render } from "./SiteCategories.vue?vue&type=template&id=1d3c15f2"
import script from "./SiteCategories.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteCategories.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SitesDash/manage/SiteCategories.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d3c15f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d3c15f2', __exports__)) {
    api.reload('1d3c15f2', __exports__)
  }
  
  module.hot.accept("./SiteCategories.vue?vue&type=template&id=1d3c15f2", () => {
    api.rerender('1d3c15f2', render)
  })

}


export default __exports__